export function formatCurrency(textNumber: string): string {
  if (!textNumber) {
    textNumber = '0';
  }
  return Number(textNumber).toLocaleString('pt-BR', {
    minimumFractionDigits: 2
  });
}

export function formatPercentualNumbers(
  textNumber: string,
  decimalFields = 1
): string {
  const idxOfDot = textNumber.indexOf('.');
  return textNumber.substring(0, idxOfDot + (decimalFields + 1));
}

export function formatNumberTon(number: string): string {
  return Number(number).toLocaleString('pt-BR', {
    minimumFractionDigits: Number(number) % 1 ? 2 : 0
  });
}

// rececbe data em string no formato YYYY-MM-DD, e devolve uma Date
export const convertStringDateToDate = (date: string): Date => {
  return new Date(
    Number(date.substring(0, 4)),
    Number(date.substring(5, 7)) - 1,
    Number(date.substring(8, 10))
  );
};

interface IFormatNumberParams {
  value: number;
  locale?: string;
  min?: number;
  max?: number;
}

export const formatNumberWithLocale = ({
  value,
  locale = 'pt-BR',
  min = 2,
  max = 2
}: IFormatNumberParams) => {
  const formatter = new Intl.NumberFormat(locale, {
    minimumFractionDigits: min,
    maximumFractionDigits: max,
    useGrouping: true
  });
  return formatter.format(value);
};
